module.exports = __webpack_public_path__ + "img/lena_gårdinger.ac308f01.png";